import React, { useState, useEffect } from 'react';
import './Plates.css';
import {usePagination} from './PaginationHook.js';

function PlatesTable({plates}) {

  if (plates.length == 0)
    return;
  
  const rows = [];

  plates.forEach((plate) => {
    rows.push(
      <tr>
        <td>{plate.number}</td>
        <td>{plate.access_rule == 'allowed' ? 'Разрешен' : 'Запрещён'}</td>
        <td>{plate.is_active ? 'активен' : 'отключен'}</td>
        <td>{plate.updated_at}</td>
        <td>
          <button>Изменить</button>
        </td>
      </tr>
    );
  });
    
  return (
    <table className='modern-table'>
      <thead>
        <tr>
          <th>Номер</th>
          <th>Права доступа</th>
          <th>Статус</th>
          <th>Дата изменения</th>
          <th>Изменить</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  );
};

export default PlatesTable;